import { NoticeTargetBranch } from '@/api'

export interface RegisterNoticeRequest {
  displayTarget: NoticeTargetBranch
  displayBranchCode: string
  displayPlaceCode: string
  displayStartDate: string
  displayEndDate: string
  body: string
}

export function RegisterNoticeRequestToJSON(value: RegisterNoticeRequest): any {
  return {
    display_target:
      value.displayTarget !== '' ? value.displayTarget : undefined,
    display_branch_code:
      value.displayBranchCode !== '' ? value.displayBranchCode : undefined,
    display_place_code:
      value.displayPlaceCode !== '' ? value.displayPlaceCode : undefined,
    display_start_date:
      value.displayStartDate !== '' ? value.displayStartDate : undefined,
    display_end_date:
      value.displayEndDate !== '' ? value.displayEndDate : undefined,
    body: value.body !== '' ? value.body : undefined
  }
}
